// extracted by mini-css-extract-plugin
export var gcpfContainer = "GiftCardPayForm_gcpfContainer__CiOHk";
export var gcpfRow = "GiftCardPayForm_gcpfRow__wZgMv";
export var gcpfTermsLink = "GiftCardPayForm_gcpfTermsLink__8wLSW";
export var gcpfWarning = "GiftCardPayForm_gcpfWarning__xuQl3";